import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

// Translation imports
import en from '../locales/en.json';
import hi from '../locales/hi.json';
import mr from '../locales/mr.json';
import bn from '../locales/bn.json';
import pa from '../locales/pa.json';
import te from '../locales/te.json';
import ta from '../locales/ta.json';
import kn from '../locales/kn.json';
import gu from '../locales/gu.json';

const translations = {
  en,
  hi,
  mr,
  bn,
  pa,
  te,
  ta,
  kn,
  gu
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [t, setT] = useState(translations.en);

  useEffect(() => {
    // Load language from localStorage or user preference
    const savedLanguage = localStorage.getItem('preferredLanguage') || 'en';
    changeLanguage(savedLanguage);
  }, []);

  const changeLanguage = (languageCode) => {
    const lang = languageCode.toLowerCase();
    if (translations[lang]) {
      setCurrentLanguage(lang);
      setT(translations[lang]);
      localStorage.setItem('preferredLanguage', lang);
    }
  };

  const translate = (key) => {
    const keys = key.split('.');
    let value = t;
    
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k];
      } else {
        return key; // Return key if translation not found
      }
    }
    
    return value;
  };

  return (
    <LanguageContext.Provider value={{ currentLanguage, changeLanguage, t: translate }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
